var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUsher(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#334368",
    fillRule: "evenodd",
    d: "M20 3.6a8.2 8.2 0 1 0 0 16.4 8.2 8.2 0 0 0 0-16.4zm0 4.2a4 4 0 1 1 0 8 4 4 0 0 1 0-8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#334368",
    fillRule: "evenodd",
    d: "M20 22.3c-6.03 0-11.33 2.2-14.1 5.52a2.1 2.1 0 0 0-.48 1.34v5.14c0 1.16.94 2.1 2.1 2.1h24.96c1.16 0 2.1-.94 2.1-2.1v-5.14c0-.49-.17-.96-.48-1.34C31.33 24.5 26.03 22.3 20 22.3zm0 4.2c4.42 0 8.28 1.44 10.38 3.42v1.98H9.62V29.9c2.1-1.97 5.96-3.41 10.38-3.41z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUsher);
export default __webpack_public_path__ + "static/media/icon-usher.2734826b3d1c8a5f69ecad65c254ae51.svg";
export { ForwardRef as ReactComponent };